import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";

export function UtilizedBudgetOverlayActivity({
    fy_list,
    storedGlobalDateId,
    activities,
    addElipsis,
    formatNumber
}) {
    const [subheadAccording, setSubheadAccording] = useState({});

const toggleSubhead = (activityId) => {
    setSubheadAccording((prev) => ({
        ...prev,
        [activityId]: !prev[activityId], // Toggle for specific activityId
    }));
};

    let finalTotalVendor = 0;
    let finalTotalDbt = 0;
    let finalTotalBudgetAllocation = 0;

    activities?.forEach((ele) => {
        finalTotalVendor += Number(ele?.current_fy?.vendor) + Number(ele?.from_prev_fy?.vendor);
        finalTotalDbt += Number(ele?.current_fy?.dbt) + Number(ele?.from_prev_fy?.dbt);
        finalTotalBudgetAllocation += Number(ele?.current_fy?.budget_allocation) + Number(ele?.from_prev_fy?.budget_allocation);
    });
    
    const grandTotal = finalTotalVendor + finalTotalDbt + finalTotalBudgetAllocation;

    return (
        <Accordion.Body className="p-2">
            <div className="row fs-12px text-black-60 p-1">
                <div className="col-2">Activity</div>
                <div className="col-2">Vendor</div>
                <div className="col-2">DBT</div>
                <div className="col-2">Salary</div>
                <div className="col-2">Budget Allocation</div>
                <div className="col-2">Total</div>
            </div>
            {
                activities?.map((ele, i) => {
                    return (
                        <>
                            <div
                                className="row fs-14px p-1 fw-500 overflow-hidden"
                                style={{
                                background: i % 2 == 0 ? "#F8F8F8" : "#FFFFFF",
                                height: !subheadAccording[ele?.activityId] ? "35px" : "fit-content",}}
                                key={ele?.activityId}
                            >
                                <div className="col-2 d-flex align-items-center">
                                {!subheadAccording[ele?.activityId] ? (
                                    <i
                                    className="icon-keyboard_arrow_right cursor-pointer"
                                    onClick={() =>
                                        toggleSubhead(ele?.activityId)
                                    }
                                    ></i>
                                ) : (
                                    <i
                                    className="icon-keyboard_arrow_down cursor-pointer"
                                    onClick={() =>
                                        toggleSubhead(ele?.activityId)
                                    }
                                    ></i>
                                )}
                                <span>{addElipsis(ele?.activityName , 13)}</span>
                                </div>
                                <div className="col-2">{

                                    (Number(ele?.current_fy?.vendor) +
                                    Number(ele?.from_prev_fy?.vendor) ) == 0 ? "-" :
                                    formatNumber((Number(ele?.current_fy?.vendor) +
                                    Number(ele?.from_prev_fy?.vendor) ), "indian")

                                }</div>
                                <div className="col-2">
                                    {
                                        (Number(ele?.current_fy?.dbt) +
                                        Number(ele?.from_prev_fy?.dbt)) == 0 ? "-" :
                                        formatNumber((Number(ele?.current_fy?.dbt) +
                                        Number(ele?.from_prev_fy?.dbt)), "indian")
                                    }
                                </div>
                                <div className="col-2">
                                    -
                                </div>
                                <div className="col-2">{
                                    (Number(ele?.current_fy?.budget_allocation) +
                                    Number(ele?.from_prev_fy?.budget_allocation)) == 0 ? "-" :
                                    formatNumber((Number(ele?.current_fy?.budget_allocation) +
                                    Number(ele?.from_prev_fy?.budget_allocation)), "indian")
                                }</div>
                                <div className="col-2 text-success-100">{
                                    (Number(ele?.current_fy?.vendor) +
                                    Number(ele?.from_prev_fy?.vendor) +
                                    Number(ele?.current_fy?.dbt) +
                                    Number(ele?.from_prev_fy?.dbt) +
                                    Number(ele?.current_fy?.budget_allocation) +
                                    Number(ele?.from_prev_fy?.budget_allocation)) == 0 ? "-" :
                                    formatNumber(
                                        (Number(ele?.current_fy?.vendor) +
                                    Number(ele?.from_prev_fy?.vendor) +
                                    Number(ele?.current_fy?.dbt) +
                                    Number(ele?.from_prev_fy?.dbt) +
                                    Number(ele?.current_fy?.budget_allocation) +
                                    Number(ele?.from_prev_fy?.budget_allocation)), "indian"
                                    )
                                }</div>

                                <div className="mt-1">
                                    <div className="row fs-14px p-1 fw-500">
                                        <div className="col-2 text-prime-100 fs-12px">FY {
                        fy_list?.map((val , ind)=>{
                          return val?.id == storedGlobalDateId && val?.year
                        })
                      }
                                        </div>
                                        <div className="col-2"> {ele?.current_fy?.vendor == 0 ? "-" : formatNumber(ele?.current_fy?.vendor , "indian")} </div>
                                        <div className="col-2">{ele?.current_fy?.dbt == 0 ? "-" : formatNumber(ele?.current_fy?.dbt, "indian")}</div>
                                        <div className="col-2">-</div>
                                        <div className="col-2">{ele?.current_fy?.budget_allocation == 0 ? "-" : formatNumber(ele?.current_fy?.budget_allocation, "indian")}</div>
                                        <div className="col-2 text-success-100">
                                        {
                                            (Number(ele?.current_fy?.vendor) +
                                            Number(ele?.current_fy?.dbt) +
                                            Number(ele?.current_fy?.budget_allocation)) == 0 ? "-" :
                                            formatNumber(
                                                (Number(ele?.current_fy?.vendor) +
                                                Number(ele?.current_fy?.dbt) +
                                                Number(ele?.current_fy?.budget_allocation)), "indian"
                                            )
                                        }
                                        </div>
                                    </div>

                                    <div className="row fs-14px p-1 fw-500">
                                        <div className="col-2 text-prime-100 fs-12px">
                                        Previous Year Balance
                                        </div>
                                        <div className="col-2">{ele?.from_prev_fy?.vendor == 0 ? "-" : formatNumber(ele?.from_prev_fy?.vendor , "indian")}</div>
                                        <div className="col-2">{ele?.from_prev_fy?.dbt == 0 ? "-" : formatNumber(ele?.from_prev_fy?.dbt , "indian")}</div>
                                        <div className="col-2">-</div>
                                        <div className="col-2">{ele?.from_prev_fy?.budget_allocation == 0 ? "-" : formatNumber(ele?.from_prev_fy?.budget_allocation , "indian")}</div>
                                        <div className="col-2 text-success-100">
                                        {
                                            (Number(ele?.from_prev_fy?.vendor) +
                                            Number(ele?.from_prev_fy?.dbt) +
                                            Number(ele?.from_prev_fy?.budget_allocation)) == 0 ? "-" :
                                            formatNumber(
                                                
                                            )
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            }
                            <div className="row fs-14px p-1 fw-500 bg-info-20">
                                <div className="col-2 text-prime-100 fs-12px">Total</div>
                                <div className="col-2">{finalTotalVendor == 0 ? "-" : formatNumber(finalTotalVendor , "indian")}</div>
                                    <div className="col-2">{finalTotalDbt == 0 ? "-" : formatNumber(finalTotalDbt , "indian")}</div>
                                    <div className="col-2">-</div>
                                    <div className="col-2">{finalTotalBudgetAllocation == 0 ? "-" : formatNumber(finalTotalBudgetAllocation , "indian")}</div>
                                    <div className="col-2 text-success-100">{grandTotal == 0 ? "-" : formatNumber(grandTotal , "indian")}</div>
                            </div>
            
        </Accordion.Body>
    )

}